import { MantineProvider } from '@mantine/core';

import EntriesPage from '~/domains/contest/domains/entries/pages';

function Entries() {
  return (
    <MantineProvider withNormalizeCSS withGlobalStyles inherit theme={{ colorScheme: 'light' }}>
      <EntriesPage />
    </MantineProvider>
  );
}

export default Entries;

Entries.hasAppBanners = false;
